import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import GridList from "@material-ui/core/GridList";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import Neighbour from "../Icons/NeighbourSolid";
import { isMobile } from "../../utils/helpers";
import { TYPES } from "../../themes/constants";
const useStyles = makeStyles(({
  breakpoints,
  palette,
  typography
}) => ({
  title: ({
    width
  }) => ({
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(width < 350 ? 14 : 15),
      marginTop: typography.pxToRem(30),
      marginBottom: typography.pxToRem(25)
    },
    fontSize: typography.pxToRem(20),
    letterSpacing: 0.44,
    marginTop: typography.pxToRem(40),
    marginBottom: typography.pxToRem(40),
    color: palette.type === TYPES.LIGHT ? palette.primary.main : palette.text.primary
  }),
  icon: {
    [breakpoints.down("xs")]: {
      marginRight: typography.pxToRem(20)
    },
    fontSize: typography.pxToRem(30),
    marginRight: typography.pxToRem(32),
    "& .neighborIcon": {
      opacity: 0.4
    }
  },
  label: {
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(14),
      letterSpacing: 0.44
    },
    fontSize: typography.pxToRem(19),
    letterSpacing: 0.44,
    color: palette.text.primary
  },
  dividerContainer: ({
    dividerPadding
  }) => ({
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    pointerEvents: "none",
    paddingTop: typography.pxToRem(dividerPadding),
    paddingBottom: typography.pxToRem(dividerPadding + 15)
  }),
  divider: {
    [breakpoints.down("sm")]: {
      display: "none"
    },
    width: typography.pxToRem(1.6),
    backgroundColor: palette.text.primary,
    opacity: 0.3,
    borderRadius: typography.pxToRem(2)
  },
  item: {
    [breakpoints.down("xs")]: {
      maxWidth: typography.pxToRem(280),
      marginBottom: typography.pxToRem(10)
    },
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: typography.pxToRem(15),
    width: typography.pxToRem(360),
    cursor: "pointer",
    "&:hover .neighborIcon": {
      opacity: 1,
      fill: palette.icon.neighbourSelected
    }
  },
  selected: {
    "& .neighborIcon": {
      opacity: 1,
      fill: palette.icon.neighbourSelected
    }
  },
  columnContainer: {
    display: "flex",
    flexDirection: "row"
  },
  listContainer: {
    position: "relative"
  },
  leftContainer: {
    marginRight: typography.pxToRem(130)
  },
  gridList: ({
    gridListHeight
  }) => ({
    [breakpoints.up("sm")]: {
      height: typography.pxToRem(300),
      overflowY: "auto",
      scrollbarWidth: "thin",
      "-ms-overflow-style": "-ms-autohiding-scrollbar",
      "&::-webkit-scrollbar": {
        width: 4,
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(170, 170, 170, 0.3)",
        borderRadius: 10
      }
    },
    [breakpoints.down("xs")]: {
      height: gridListHeight,
      maxHeight: typography.pxToRem(280)
    },
    maxHeight: gridListHeight,
    scrollbarColor: "rgba(170, 170, 170, 0.3) transparent",
    scrollbarWidth: "thin",
    overflowX: "hidden"
  })
}));

const AddressItem = ({
  address,
  onClick,
  isSelected
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.item, isSelected && styles.selected),
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Neighbour, {
    className: styles.icon
  }), /*#__PURE__*/React.createElement(Typography, {
    className: styles.label
  }, address));
};

const SelectNeighbourList = ({
  title,
  addresses,
  selectedAddress,
  onSelect,
  onSubmit,
  getAddressLabel,
  width
}) => {
  const gridListHeight = window.innerHeight - (isMobile ? 400 : 480);
  const styles = useStyles({
    width: window.innerWidth,
    gridListHeight,
    dividerPadding: addresses.length < 5 ? 0 : 20
  });
  const isTwoColumns = addresses.length > 1 && isWidthUp("md", width);

  const isEven = num => num % 2 === 0;

  const addressesList = addresses.map((address, index) => /*#__PURE__*/React.createElement(AddressItem, {
    key: index,
    address: getAddressLabel(address),
    onClick: () => onSelect(address),
    isSelected: address === selectedAddress
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles.listContainer
  }, isTwoColumns && /*#__PURE__*/React.createElement("div", {
    className: styles.dividerContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.divider
  })), /*#__PURE__*/React.createElement(GridList, {
    className: styles.gridList
  }, isTwoColumns ? /*#__PURE__*/React.createElement("div", {
    className: styles.columnContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.leftContainer
  }, addressesList.filter((address, index) => isEven(index))), /*#__PURE__*/React.createElement("div", null, addressesList.filter((address, index) => !isEven(index)))) : /*#__PURE__*/React.createElement("div", null, addressesList))));
};

export default withWidth()(SelectNeighbourList);